import { basicResetReducer } from '@ackee/redux-utils';
import { combineReducers } from 'redux';

import { authSessionEnd } from '@/modules/auth/services/actions';
import { apiReducer as groups } from '@/modules/groups';
import { MODULE_PREFIX as IMPORT_EXPORT_MODULE_PREFIX } from '@/modules/import-export/constants';
import { default as importExport } from '@/modules/import-export/services/reducers/api';
import { apiReducer as secrets } from '@/modules/secrets';
import { apiReducer as tags } from '@/modules/secrets/modules/tags';
import { apiReducer as securityAudit, constants as securityAuditConstants } from '@/modules/security-audit';
import { apiReducer as settings } from '@/modules/settings/services/reducers/api';
import { apiReducer as whitelist } from '@/modules/whitelist';

const apiReducer = combineReducers({
    secrets,
    groups,
    settings,
    whitelist,
    tags,
    [securityAuditConstants.MODULE_PREFIX]: securityAudit,
    [IMPORT_EXPORT_MODULE_PREFIX]: importExport,
});

const resetReducer = basicResetReducer(apiReducer, authSessionEnd.toString());

export default resetReducer;
